import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { orderActions } from "../../store/slices/orderSlice";
import ActiveCleaningRequestsCustomer from "../ActiveCleaningRequestsCustomer/ActiveCleaningRequestsCustomer";
import HistoryCleaningRequests from "../HistoryCleaningRequests/HistoryCleaningRequests";
import styles from './OrdersList.module.scss';

const OrdersList = ({handleDeleteOrder}) => {
    const [tabOption, setTabOption] = useState('Активні');

    const {activeCleaningRequestsByCurrentUser, historyCleaningRequests} = useSelector(state => state.cleaningRequests);

    const handleSetTabOption = (option) => {
        setTabOption(option);
    }

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(orderActions.getByCurrentUser());
    }, [dispatch])

    return (
        <div className={styles.ordersList_wrapper}>
            <div className={styles.ordersList_wrapper_content}>
                <h2 className={styles.ordersList_wrapper_content_title}>Ваші замовлення</h2>

                <ul className={styles.ordersList_wrapper_content_options}>
                    <li
                        onClick={() => handleSetTabOption('Активні')}
                        className={`${styles.ordersList_wrapper_content_options_item} ${tabOption === 'Активні' ? styles.active : ''}`}
                    >
                        Активні (<span>{activeCleaningRequestsByCurrentUser?.length}</span>)
                    </li>
                    <li
                        onClick={historyCleaningRequests?.length > 0 ? () => handleSetTabOption('Історія') : null}
                        className={`${styles.ordersList_wrapper_content_options_item} 
                        ${tabOption === 'Історія' ? styles.active : ''}
                        ${historyCleaningRequests?.length === 0 ? styles.disabled : ''}`}
                    >Історія
                    </li>
                </ul>

                {tabOption === 'Активні' &&
                    <ActiveCleaningRequestsCustomer handleDeleteOrder={handleDeleteOrder}/>}

                {tabOption === 'Історія' &&
                    <HistoryCleaningRequests/>}
            </div>
        </div>
    );
};

export default OrdersList;
